import PageState from './state';
import mutations from './mutations';
import { getModule } from '@/store/store';
let APIS = {
  //模版类型列表
  getTypeList: `/apis/tts-web-api/template/video/typeList`,
  //模版列表
  getTemplateList: `/apis/tts-web-api/template/video/template/page`,
};
export default {
  ...getModule({
    state: new PageState(),
    mutations,
    actions: {},
    APIS,
    name: 'sameStylePage',
  }),
};
